import { render, staticRenderFns } from "./approval-sumary.vue?vue&type=template&id=62e02e6e&"
import script from "./approval-sumary.vue?vue&type=script&lang=js&"
export * from "./approval-sumary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports